<template>
  <vs-popup class="add-new-incoterms"
            id="popup"
            :title="isCreateMode ? 'ADD QC TEST' : 'UPDATE QC TEST'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-rm-qc-test-popup" @submit.prevent="handleSubmit(onClickCreateRmQcTest)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="form.description" height="100px"/>
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Type</small>
                <v-select name="type" :closeOnSelect="true" v-model="form.type" :options="['TR', 'TXT', 'NR']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="is_mandatory" name="is_mandatory" rules="" v-slot="{ errors }">
                <small class="label">Is Mandatory?</small>
                <v-select name="is_mandatory" :closeOnSelect="true" label="name" :reduce="option => option.value" v-model="form.is_mandatory" :options="[{name: 'Yes', value: true}, {name: 'No', value: false}]" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-ccp-items-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        address: {}
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'AddNewCcpItemPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchRmQcTestDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchRmQcTestDetails() {
        await this.$vs.loading({
          container: '#create-rm-qc-test-popup',
          scale: 0.45
        })
        try {
          const {data} = (await SupplierRawMaterialRepository.getSingleRawMaterialQCTest(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-rm-qc-test-popup > .con-vs-loading')
      },
      async onClickCreateRmQcTest() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-rm-qc-test-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            await SupplierRawMaterialRepository.createRawMaterialQCTest(this.form)
            this.showSuccessMessage('QC Test added!');
          } else {
            await SupplierRawMaterialRepository.updateRawMaterialQCTest(this.id, this.form)
            this.showSuccessMessage('QC Test updated!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-rm-qc-test-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-rm-qc-test-popup > .con-vs-loading')
      },
    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-incoterms >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
